// extracted by mini-css-extract-plugin
module.exports = {"title":"accountMenu_title__3og6w","categoryList":"accountMenu_categoryList__MUK2I","icon":"accountMenu_icon__JfE7A","icon2":"accountMenu_icon2__RZArK"};